import { B100, B400, B75, DN30, DN300A, DN600, DN70, N0, N50, N900, P300, P400, P75 } from '@atlaskit/theme/colors';
import { themed } from '@atlaskit/theme/components';
// TODO Token usages are not consistent for dots https://product-fabric.atlassian.net/browse/DSP-3180
const colorMap = {
  default: themed({
    light: `var(--ds-background-neutral, ${N50})`,
    dark: `var(--ds-background-neutral, ${DN70})`
  }),
  help: themed({
    light: `var(--ds-background-neutral, ${P75})`,
    dark: `var(--ds-background-neutral, ${DN70})`
  }),
  inverted: themed({
    light: "var(--ds-icon-subtle, rgba(255, 255, 255, 0.4))",
    dark: `var(--ds-icon-subtle, ${DN300A})`
  }),
  primary: themed({
    light: `var(--ds-background-neutral, ${B75})`,
    dark: `var(--ds-background-neutral, ${DN70})`
  })
};
const selectedColorMap = {
  default: themed({
    light: `var(--ds-icon, ${N900})`,
    dark: `var(--ds-icon, ${DN600})`
  }),
  help: themed({
    light: `var(--ds-icon-discovery, ${P400})`,
    dark: `var(--ds-icon-discovery, ${P300})`
  }),
  inverted: themed({
    light: `var(--ds-icon-inverse, ${N0})`,
    dark: `var(--ds-icon-inverse, ${DN30})`
  }),
  primary: themed({
    light: `var(--ds-icon-brand, ${B400})`,
    dark: `var(--ds-icon-brand, ${B100})`
  })
};
export const getBgColor = (appearance, isSelected) => isSelected ? selectedColorMap[appearance] : colorMap[appearance];